import React, { useContext, useEffect, useRef, useState } from 'react'

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';

// ------------------ COMPONENTES DE BASE--------------------------
import Card from '../../../../../Base/Components/Card/Card'
import { setTitlePage } from '../../../../../Base/Services/Config/ConfigService';
import AgGrid from '../../../../../Base/Components/Tables/AgGrid/AgGrid';
import { AuthContext } from '../../../../../Base/Context/AuthContext/AuthContext';
import { toastShow } from '../../../../../Base/Services/ToastService';
import { getLabel } from '../../../../../Base/Services/Language/LanguageService';
import { baseLang } from '../../../../../Base/Lang/BaseLang';
import { ConfigContext } from '../../../../../Base/Context/ConfigContext/ConfigContext';
import { EnviarCorreoAsignacionR } from '../../../../../Base/Services/Email/EnviarCorreo';

// ------------------- CONSULTAS A LA API---------------------------
import { getListaRequisasAutorizarBodega } from '../../../../../API/Compras/Requisas/PurchaseRequest';
import { ChangeAuth1, getAutorizaciones } from '../../../../../API/Compras/Autorizaciones/AutorizacionesRequest';
import { getDetalleRequisaID, getEncabezadoRequisaID } from '../../../../../API/Compras/RequisiscionCompras/PurchaseRequestDetails';

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import CrudRequisa from '../CrudRequisa/CrudRequisa';

const LiberarBodegaScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [password, setPassword] = useState("");
  const [showModal, setModal] = useState(false);
  const [requisaEdit, setRequisaEdit] = useState(null);
  const [Autorizaciones, setAutorizaciones] = useState([]);
  const [habilitar, setHabilitar] = useState(true);
  const [loadingCorreo, setLoadingCorreo] = useState(false);

  // ACA SOLO VA ESTE ACCESO
  // ACCESOS DE LIBERAR BODEGA   
  const [hiddenliberarBodega, setHiddenLiberarBodega] = useState(
    userAuth.AccessWeb.split(",")
      .map((e) => parseInt(e))
      .includes(33)
  );

  // ACCESO DE LIBERAR REQUISA COMPRAS - GERENTE AREA
  const [hiddenliberarRequisa, setHiddenLiberarRequisa] = useState(
    userAuth.AccessWeb.split(",")
      .map((e) => parseInt(e))
      .includes(27)
  );

  // ACCESO APROBAR REQUISA FINANZAS
  const [hiddenAprobarRequisaFinanzas, setHiddenAprobarRequisaFinanzas] =
    useState(
      userAuth.AccessWeb.split(",")
        .map((e) => parseInt(e))
        .includes(30)
    );

  // ACCESO APROBAR REQUISA GERENTE PLANTA
  const [hiddenAprobarRequisaGerentePlanta,setHiddenAprobarRequisaGerentePlanta,] = 
    useState(
        userAuth.AccessWeb.split(",")
        .map((e) => parseInt(e))
        .includes(32)
    );

  const getInfo = async () => {
    setLoading(true);
    const t = await getListaRequisasAutorizarBodega();
    setData(t);
    setLoading(false);

    const autorizacionesData = await getAutorizaciones();
    setAutorizaciones(
      autorizacionesData.filter((autorizacion) => autorizacion.IdTipo === 9)
    );
  };

  // CAMBIAR FIRMAS DE REVISION BODEGA
  const handleCheckboxChange = async (
    event,
    data,
    IdPermisoGeneral,
    NombrePermiso
  ) => {
    const dataToSend = data.map((item) => {
      return {
        IdPurcharesRequestDetail: item?.IdPurcharesRequestDetail,
        IdPermisoGeneral: IdPermisoGeneral,
        Autorizo: !item[NombrePermiso],
        IdUsuarioAutorizo: userAuth?.IdUser,
      };
    });
    confirmDialog({
      message: `¿Está seguro que desea liberar ${data.length} ${
        data.length > 1 ? "permisos" : "permiso"
      }?`,
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        const respuestaDetalles = await ChangeAuth1(dataToSend);
        if (respuestaDetalles[0]?.ESTADO === 1) {
          toastShow(toast, "success", "Guardado", respuestaDetalles[0].MENSAGE);
          getInfo();
          enviarCorreoAgente(respuestaDetalles)
        } else {
          toastShow(toast, "error", "Error", respuestaDetalles[0].MENSAGE);
        }
      },
      reject: () => {},
    });
    setSelected([]);
  };

  const enviarCorreoAgente = async (respuestaDetalles) => {
    if (respuestaDetalles[0]?.ESTADO === 1) {
      for (const detalle of respuestaDetalles) {
        const IdPurchaseRequest = detalle?.IdPurcharesRequest;
        if (detalle.IdStatus === 14) {
          const encabezado = await getEncabezadoRequisaID(IdPurchaseRequest);
          const detalles = await getDetalleRequisaID(IdPurchaseRequest);
          enviarAsignacion(null, encabezado[0], detalles)
        }
      }
    }
  }

  const enviarAsignacion = async (mostrarToast = null, encabezado, detalles) => {
    const emailAgente = detalles[0]?.EmailAgente;
    const emailEdit = detalles[0]?.EmailEdit;
    const emailSolicita = detalles[0]?.EmailSolicita;

    EnviarCorreoAsignacionR({
        setLoadingCorreo,
        toast,
        showToas: true,
        to: [emailAgente, emailSolicita].join(", "),
        bcc: emailEdit,
        subject: `Asignación de Requisición No. ${encabezado?.PurchaseRequest} / ${encabezado?.Area}`,
        encabezado: encabezado,
        detalles: detalles,
        // attachments: d,
        mostrarToast: mostrarToast
    });
  };

  const columns = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdPurcharesRequestDetail",
      frozen: true,
      className: "Xsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      header: "Fecha",
      headerEn: "Date",
      field: "DateCreated",
      Format: "DateTime2",
      frozen: true,
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      Format: "Estado",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      className: "medium",
      frozen: true,
    },
    {
      // NUMERO ORDEN
      field: "PurchaseRequest",
      header: "No. Requisa",
      header: "No. Requisistion",
      className: "small",
      body: (rowData) => rowData.PurchaseRequest,
      frozen: "frozen",
      alignFrozen: "left",
      Sumary: "count",
      align: "center",
      Format: "Modal",
    },
    {
      header: "Codigo Producto",
      headerEn: "Product Code",
      field: "CodigoProducto",
      className: "small",
      // frozen: 'true',
    },
    {
      header: "Producto",
      header: "Product",
      field: "NombreProducto",
      className: "XXlarge",
      Sumary: "count",
      // frozen: 'true',
    },
    {
      header: "Descripción",
      headerEn: "Description",
      field: "Description",
      className: "large",
    },
    {
      header: "Cantidad",
      headerEn: "Quantity",
      field: "Minimo",
      className: "small",
      Format: "Decimal",
      Sumary: "sum",
    },
    {
      header: "Inventario",
      headerEn: "Inventary",
      field: "Inventario",
      className: "small",
      Format: "Decimal",
    },

    {
      header: "Área",
      headerEn: "Area",
      field: "Area",
    },
    {
      header: "Unidad",
      headerEn: "Unit",
      field: "UnitName",
      className: "small",
    },
    {
      header: "Comentario",
      headerEn: "Comment",
      field: "Comment",
      className: "large",
    },
    ...Autorizaciones.map((autorizacion) => {
      return {
        field: autorizacion?.NombrePermiso,
        header: autorizacion.NombrePermiso,
        frozen: true,
        alignFrozen: "right",
        align: "center",
        className: "Xsmall",
        Format: "Checkbox",
        filter: false,
        hidden: hiddenliberarBodega,
        onChange: (event, { data }) => {
          if (autorizacion?.IdPermisoGeneral === 4) {
            if (selected.length === 0) {
              handleCheckboxChange(
                event,
                [data],
                autorizacion?.IdPermisoGeneral,
                autorizacion.NombrePermiso
              );
            } else {
              handleCheckboxChange(
                event,
                selected,
                autorizacion?.IdPermisoGeneral,
                autorizacion.NombrePermiso
              );
            }
          }
        },
      };
    }),
  ];

  const table = {
    Data: data,
    Columns: columns,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
    showModal: (purchaseRequest) => {
      setRequisaEdit(purchaseRequest);
      setModal(true);
    },
  };

  const onHide = () => {
    setModal(false);
    setRequisaEdit(null);
    setPassword("");
  };

  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && requisaEdit !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
        onHide() // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
        onHide()
    }
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "liberarBodega", config.language));
    getInfo();
  }, []);

  return (
    <div>
      <Toast ref={toast} />
      <Dialog
        visible={showModal}
        onHide={() => {cerrarConfirmacion()}}
        closeOnEscape={false}
        maximized={true}
      >
        <CrudRequisa
          idRequisa={requisaEdit}
          setRequisaToShow={setRequisaEdit}
          actualizarRequisasScreen={getInfo}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
        />
      </Dialog>
      <Card
        titulo={
          <div className="botones">
            <h2>{getLabel(baseLang, "liberarBodega", config.language)}</h2>
            <Button icon="pi pi-refresh" onClick={getInfo} />
          </div>
        }
        contenido={
          <div className="mt-4" style={{ height: "88vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
    </div>
  );
}

export default LiberarBodegaScreen